import React from 'react';

const ACCENT = '#E52E3A';

export function Spinner({ size = 'md', className = '' }) {
  const sizes = { sm: 14, md: 22, lg: 30 };
  const s = sizes[size] || sizes.md;
  return (
    <svg
      className={`animate-spin ${className}`}
      width={s} height={s}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" stroke={ACCENT} strokeWidth="2" opacity="0.15" />
      <path
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
        fill={ACCENT}
        opacity="0.8"
      />
    </svg>
  );
}

export function LoadingDots({ message }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '4px 0' }}>
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
        {[0, 1, 2].map(i => (
          <div key={i} style={{
            width: '3px', height: '12px',
            background: ACCENT,
            animation: `pulse 1.2s ease-in-out ${i * 0.15}s infinite`,
          }} />
        ))}
      </div>
      {message && (
        <div style={{
          fontSize: '11px', color: '#6A6A70', fontWeight: 600,
          letterSpacing: '0.04em', textTransform: 'uppercase',
        }}>
          {message}
        </div>
      )}
    </div>
  );
}

export function LoadingOverlay({ message = 'Loading...' }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 space-y-4">
      <Spinner size="lg" />
      <p style={{
        fontSize: '10px', color: '#6A6A70', fontWeight: 700,
        letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: '16px',
      }}>
        {message}
      </p>
    </div>
  );
}
